import getField from '@form/formGenerator'

export const documentSaveUrl = `${import.meta.env.VITE_API_URL}/api/documents`

export const documentFormObject = {
  name: '',
  document: ''
}

export const documentFormFields = (documentFormObject, updateFormObject, updateFormObjectProp, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'text',
      name: 'name',
      label: t('labels.document_name'),
      value: documentFormObject.name,
      key: 'documentFormObject-name',
      cssClass: 'column is-12',
      isRequired: true
    },
    {
      type: 'file',
      name: 'document',
      cssClass: 'column is-12 document',
      simpleInput: false,
      key: 'documentFormObject-document',
      disabled: false,
      label: t('labels.document_file'),
      targetUrl: `${import.meta.env.VITE_API_URL}/api/push/temp-files`,
      fileType: 'document',
      isRequired: true
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'documentFormObject-form',
      isLoading
    }
  ]

  return fields.map(function (field) {
    return getField({
      ...field,
      error: errors[field.name] ? errors[field.name].errors : ''
    }, updateFormObject, updateFormObjectProp)
  })
}
